// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-description-new":"ListingDescription_hz-Listing-description-new__KKQ0_"};